






// import React, { useState } from 'react';

// const ContactForm = () => {



//     const [formData, setFormData] = useState({
//         name: "",
//         email: "",
//         phone: "",
//         date: "",
//         gender: "",
//         message: "",
//         plan: "",
//         cources: "",
//         resume: '',
//     });



//     const handleChange = (e) => {
//         const { id, value } = e.target;
//         setFormData((prev) => ({
//             ...prev,
//             [id]: value,
//         }));
//     };

//     const handleResumeUpload = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             const reader = new FileReader();
//             reader.onloadend = () => {
//                 const base64String = reader.result.split(',')[1]; // remove prefix
//                 setFormData((prev) => ({
//                     ...prev,
//                     resume: base64String, // clean base64 only
//                 }));
//             };
//             reader.readAsDataURL(file);
//         }
//     };

//     const [loading, setLoading] = useState(false);
//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);

//         const payload = {
//             name: formData.name,
//             emailId: formData.email,
//             mobileNumber: formData.phone,
//             gender: formData.gender,
//             dateOfBirth: formData.date,
//             message: formData.message,
//             plan: formData.plan,
//             cources: formData.cources,
//             resume: formData.resume, // ✅ include base64 resume here
//         };

//         try {
//             const response = await fetch("https://iiaserver.iiautomate.com/IIA-Website-1.0.0/enquiry/add/enquiry", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 body: JSON.stringify(payload)
//             });

//             if (response.ok) {
//                 alert("Your details have been submitted successfully!");
//             } else {
//                 alert("There was an issue submitting your details.");
//             }
//         } catch (error) {
//             console.error("Upload error:", error);
//             alert("Something went wrong. Please try again later.");
//         }
//         finally {
//             setLoading(false);
//         }
//     };


//     const inputStyle = {
//         width: "100%",
//         padding: "10px",
//         border: "1px solid #ccc",
//         borderRadius: "5px",
//         fontSize: "14px",
//         fontFamily: "Roboto",
//         marginBottom: "15px"
//     };



//     return (
//         <>
//             <section aria-label="section" className="no-bottom">
//                 <div className="container-fluid">
//                     <div className="row p-3-vh">
//                         <div className="col-12 centered my-o">
//                             <div className="detailcontent text-center p-0">
//                                 {/* <div className="heading" style={{ color: 'blue', letterSpacing: '0.025em' }}>
//                                     Get in touch{' '}
//                                     <span className="color" style={{ color: 'orange', letterSpacing: '0.025em' }}>
//                                         with us
//                                     </span>
//                                 </div> */}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>

//             <section aria-label="contact" style={{ padding: '20px' }}>
//                 <div className="container-fluid">
//                     <div style={{marginTop:"60px"}}>
//                         <h2 style={{ textAlign: 'center', fontFamily: 'Roboto', marginBottom: '20px', fontSize: '22px', fontWeight: 'bold',color:'white' }}>
//                             Welcome to <span style={{ color: "white" }}>International Institute of </span>
//                             <span style={{ color: "orange" }}>Automate</span>
//                         </h2>
//                     </div>
//                     <div className="row p-3-vh">

//                         <div className="col-md-6">
//                             <iframe
//                                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7610.7433924449315!2d78.38240638937562!3d17.489761383659552!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb918dab342375%3A0x180a04af0c47f594!2sManjeera%20Trinity%20Corporate!5e0!3m2!1sen!2sin!4v1723212055136!5m2!1sen!2sin"
//                                 width="100%"
//                                 height="560"
//                                 style={{ border: 0 }}
//                                 allowFullScreen=""
//                                 loading="lazy"
//                                 referrerPolicy="no-referrer-when-downgrade"
//                             ></iframe>
//                         </div>

//                         {/* Right side: Contact Form */}
//                         <div className="col-md-6">

//                             <form
//                                 onSubmit={handleSubmit}
//                                 style={{
//                                     maxWidth: "600px",
//                                     height: "568px", // adjust height as needed
//                                     overflowY: "auto", // enables vertical scroll
//                                     margin: "0 auto",
//                                     backgroundColor: "#eef6fc",
//                                     padding: "30px",
//                                     borderRadius: "5px",
//                                     boxShadow: "0 0 10px rgba(0,0,0,0.1)"
//                                 }}
//                             >

//                                 <input id="name" value={formData.name} onChange={handleChange} type="text" required placeholder=" Name" style={inputStyle} />


//                                 <input id="email" value={formData.email} onChange={handleChange} type="email" required placeholder=" Email" style={inputStyle} />


//                                 <input id="phone" value={formData.phone} onChange={handleChange} type="tel" required placeholder=" Phone" style={inputStyle} />


//                                 <input id="date" value={formData.date} onChange={handleChange} type="date" required style={inputStyle} />


//                                 <select id="gender" value={formData.gender} onChange={handleChange} required style={inputStyle}>
//                                     <option value="">Select Gender</option>
//                                     <option value="Male">Male</option>
//                                     <option value="Female">Female</option>
//                                     <option value="Other">Other</option>
//                                 </select>


//                                 <select id="cources" name="cources" value={formData.cources} onChange={handleChange} required style={inputStyle}>
//                                     <option value="">Select Courses</option>
//                                     <option value="VirualRoboticsSimulation">Robotics Virtual Simulation</option>
//                                     <option value="ToolandFixtureDesign">Tool & Fixture Design</option>
//                                     <option value="DigitalFactorySolution">Digital Factory Solution</option>
//                                     <option value="JavaFullStackDevelopers">Java Full Stack Developers</option>
//                                     <option value="PythonFullStackDevelopers">Python Full Stack Developers</option>
//                                     <option value="ReactJsAndFlutterDevelopers">React & Flutter Developers</option>
//                                     <option value="CareerFoundationSkills">Career Foundation Skill</option>
//                                     <option value="SoftSkillsEnhancement">Soft Skill</option>
//                                     <option value="DigitalPresenceSkills">Digital Presence Skill</option>
//                                 </select>


//                                 <select id="plan" value={formData.plan} onChange={handleChange} required style={inputStyle}>
//                                     <option value="">Select Plan</option>
//                                     <option value="Industrial_Oriented_Training_Program">Industrial Oriented Training Program</option>
//                                     <option value="Job_Oriented_Placement_Program">Job Oriented Placement Program</option>
//                                 </select>


//                                 <input
//                                     type="file"
//                                     id="resume"
//                                     name="resume"
//                                     accept=".pdf,.doc,.docx"
//                                     onChange={handleResumeUpload}
//                                     style={{ ...inputStyle, padding: "10px", cursor: "pointer" }}
//                                 />


//                                 <textarea
//                                     id="message"
//                                     value={formData.message}
//                                     onChange={handleChange}
//                                     placeholder="Enter your message"
//                                     rows="4"
//                                     required
//                                     style={{ ...inputStyle, resize: "vertical" }}
//                                 />

//                                 <button
//                                     type="submit"
//                                     disabled={loading}
//                                     style={{
//                                         padding: "12px",
//                                         fontSize: "16px",
//                                         backgroundColor: "blue",
//                                         color: "#fff",
//                                         border: "none",
//                                         borderRadius: "25px",
//                                         fontWeight: "bold",
//                                         fontFamily: "Roboto",
//                                         cursor: loading ? "not-allowed" : "pointer",
//                                         marginTop: "5px",
//                                         width: "100%"
//                                     }}
//                                 >
//                                     {loading ? "Submitting..." : "SEND ENQUIRY"}
//                                 </button>
//                             </form>

//                         </div>

//                     </div>
//                 </div>
//             </section>
//         </>
//     );
// };

// export default ContactForm;



// import React, { useState } from "react";
// import contactImg from "../img/aaaservices/vr-picture1.0500ab64429db7be0373.jpg"; // apni image ka path dalna

// const ContactForm = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     date: "",
//     gender: "",
//     message: "",
//     plan: "",
//     cources: "",
//     resume: "",
//   });

//   const handleChange = (e) => {
//     const { id, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [id]: value,
//     }));
//   };

//   const handleResumeUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         const base64String = reader.result.split(",")[1];
//         setFormData((prev) => ({
//           ...prev,
//           resume: base64String,
//         }));
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const payload = {
//       name: formData.name,
//       emailId: formData.email,
//       mobileNumber: formData.phone,
//       gender: formData.gender,
//       dateOfBirth: formData.date,
//       message: formData.message,
//       plan: formData.plan,
//       cources: formData.cources,
//       resume: formData.resume,
//     };

//     try {
//       const response = await fetch(
//         "https://iiaserver.iiautomate.com/IIA-Website-1.0.0/enquiry/add/enquiry",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(payload),
//         }
//       );

//       if (response.ok) {
//         alert("Your details have been submitted successfully!");
//       } else {
//         alert("There was an issue submitting your details.");
//       }
//     } catch (error) {
//       console.error("Upload error:", error);
//       alert("Something went wrong. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const inputStyle = {
//     width: "100%",
//     padding: "10px",
//     border: "1px solid #ccc",
//     borderRadius: "5px",
//     fontSize: "14px",
//     fontFamily: "Roboto",
//     marginBottom: "15px",
//   };

//   return (
//     <>
//       <section aria-label="contact" style={{ padding: "20px" }}>
//         <div className="container-fluid">
//           <div style={{ marginTop: "60px" }}>
//             <h2
//               style={{
//                 textAlign: "center",
//                 fontFamily: "Roboto",
//                 marginBottom: "20px",
//                 fontSize: "22px",
//                 fontWeight: "bold",
//                 color: "white",
//               }}
//             >
//               Welcome to{" "}
//               <span style={{ color: "white" }}>
//                 International Institute of{" "}
//               </span>
//               <span style={{ color: "orange" }}>Automate</span>
//             </h2>
//           </div>

//           <div className="row p-3-vh">
//             {/* Left side: Image */}
//             <div className="col-md-6 mb-4">
//               <img
//                 src={contactImg}
//                 alt="Contact"
//                 style={{
//                   width: "100%",
//                   height: "560px",
//                   objectFit: "conatain",
//                   borderRadius: "5px",
//                 }}
//               />
//             </div>

//             {/* Right side: Contact Form */}
//             <div className="col-md-6">
//               <form
//                 onSubmit={handleSubmit}
//                 style={{
//                   maxWidth: "600px",
//                   height: "568px",
//                   overflowY: "auto",
//                   margin: "0 auto",
//                   backgroundColor: "#eef6fc",
//                   padding: "30px",
//                   borderRadius: "5px",
//                   boxShadow: "0 0 10px rgba(0,0,0,0.1)",
//                 }}
//               >
//                 <input
//                   id="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   type="text"
//                   required
//                   placeholder="Name"
//                   style={inputStyle}
//                 />

//                 <input
//                   id="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   type="email"
//                   required
//                   placeholder="Email"
//                   style={inputStyle}
//                 />

//                 <input
//                   id="phone"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   type="tel"
//                   required
//                   placeholder="Phone"
//                   style={inputStyle}
//                 />

//                 <input
//                   id="date"
//                   value={formData.date}
//                   onChange={handleChange}
//                   type="date"
//                   required
//                   style={inputStyle}
//                 />

//                 <select
//                   id="gender"
//                   value={formData.gender}
//                   onChange={handleChange}
//                   required
//                   style={inputStyle}
//                 >
//                   <option value="">Select Gender</option>
//                   <option value="Male">Male</option>
//                   <option value="Female">Female</option>
//                   <option value="Other">Other</option>
//                 </select>

//                 {/* <select
//                   id="cources"
//                   value={formData.cources}
//                   onChange={handleChange}
//                   required
//                   style={inputStyle}
//                 >
//                   <option value="">Select Courses</option>
//                   <option value="VirualRoboticsSimulation">
//                     Robotics Virtual Simulation
//                   </option>
//                   <option value="ToolandFixtureDesign">
//                     Tool & Fixture Design
//                   </option>
//                   <option value="DigitalFactorySolution">
//                     Digital Factory Solution
//                   </option>
//                   <option value="JavaFullStackDevelopers">
//                     Java Full Stack Developers
//                   </option>
//                   <option value="PythonFullStackDevelopers">
//                     Python Full Stack Developers
//                   </option>
//                   <option value="ReactJsAndFlutterDevelopers">
//                     React & Flutter Developers
//                   </option>
//                   <option value="CareerFoundationSkills">
//                     Career Foundation Skill
//                   </option>
//                   <option value="SoftSkillsEnhancement">
//                     Soft Skill
//                   </option>
//                   <option value="DigitalPresenceSkills">
//                     Digital Presence Skill
//                   </option>
//                 </select> */}

//                 {/* <select
//                   id="plan"
//                   value={formData.plan}
//                   onChange={handleChange}
//                   required
//                   style={inputStyle}
//                 >
//                   <option value="">Select Plan</option>
//                   <option value="Industrial_Oriented_Training_Program">
//                     Industrial Oriented Training Program
//                   </option>
//                   <option value="Job_Oriented_Placement_Program">
//                     Job Oriented Placement Program
//                   </option>
//                 </select> */}

//                 <input
//                   type="file"
//                   id="resume"
//                   accept=".pdf,.doc,.docx"
//                   onChange={handleResumeUpload}
//                   style={{
//                     ...inputStyle,
//                     padding: "10px",
//                     cursor: "pointer",
//                   }}
//                 />

//                 <textarea
//                   id="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   placeholder="Enter your message"
//                   rows="4"
//                   required
//                   style={{ ...inputStyle, resize: "vertical" }}
//                 />

//                 <button
//                   type="submit"
//                   disabled={loading}
//                   style={{
//                     padding: "12px",
//                     fontSize: "16px",
//                     backgroundColor: "blue",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: "25px",
//                     fontWeight: "bold",
//                     fontFamily: "Roboto",
//                     cursor: loading ? "not-allowed" : "pointer",
//                     marginTop: "5px",
//                     width: "100%",
//                   }}
//                 >
//                   {loading ? "Submitting..." : "SEND ENQUIRY"}
//                 </button>
//               </form>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default ContactForm;



import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import contactImg from "../img/aaaservices/vr-picture1.0500ab64429db7be0373.jpg";

const ContactForm = () => {
  const navigate = useNavigate();
   const [loading, setLoading] = useState(false);
const [resume, setResume] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    dob: "",
    gender: "",
    message: "",
    cource: "Virtual_Robotics", // default enum value
  });

  

  // Format date if backend needs specific format
  const formatDate = (date) => {
    if (!date) return "";
    return date;
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleResumeUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setResume(file);
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  const payload = new FormData();
  payload.append("name", formData.name);
  payload.append("email", formData.email);
  payload.append("phone", formData.phone);
  payload.append("gender", formData.gender);
  payload.append("cource", formData.cource);
  payload.append("dob", formatDate(formData.dob));
  payload.append("message", formData.message);

  if (resume) {
    payload.append("attachment", resume);
  }

  try {
    const response = await fetch(
      "https://backend.maamaas.com/iia/api/enquiry",
      {
        method: "POST",
        body: payload,
      }
    );

    let data;
    const text = await response.text();

    try {
      data = JSON.parse(text);
    } catch {
      data = { message: text };
    }

    if (!response.ok) {
      throw new Error(data.message || "Submission failed");
    }

    alert(data.message || "Enquiry submitted successfully ✅");

    setFormData({
      name: "",
      email: "",
      phone: "",
      dob: "",
      gender: "",
      message: "",
      cource: "Virtual_Robotics",
    });

    setResume(null);
  } catch (error) {
    console.error(error);
    alert(error.message || "Server or CORS Error ❌");
  } finally {
    setLoading(false);
  }
};




  const inputStyle = {
    width: "100%",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    fontSize: "14px",
    marginBottom: "15px",
  };

  return (
    <section style={{ padding: "20px" }}>
      <div className="container-fluid">
        <div style={{ marginTop: "60px" }}>
             <h2
              style={{
                textAlign: "center",
                fontFamily: "Roboto",
                marginBottom: "20px",
                fontSize: "22px",
                fontWeight: "bold",
                color: "white",
              }}
            >
              Welcome to{" "}
              <span style={{ color: "white" }}>
                International Institute of{" "}
              </span>
              <span style={{ color: "orange" }}>Automate</span>
            </h2>
          </div>
        <div className="row p-3-vh">

          {/* LEFT IMAGE WITH OVERLAY */}
          <div className="col-md-6 mb-4">
            <div style={{ position: "relative" }}>
              
              {/* Back Button */}
              <button
                onClick={() => navigate("/Secondactiveprograms")}
                style={{
                  position: "absolute",
                  top: "15px",
                  left: "15px",
                  background: "rgba(248, 156, 8, 0.87)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  fontSize: "20px",
                  cursor: "pointer",
                  zIndex: 2,
                }}
              >
                ←
              </button>

              {/* Course Name */}
   
<div
  style={{
    position: "absolute",
    bottom: "230px",
    left: "50%",
    transform: "translateX(-50%)",
    background: "rgba(248, 156, 8, 0.87)",
    color: "#fff",

    width: "90%",
    maxWidth: "900px",

    padding: "20px 40px",
    borderRadius: "10px",

    fontSize: "clamp(16px, 2.2vw, 24px)",
    fontWeight: "900",
    textAlign: "center",
    lineHeight: "1.4",
    letterSpacing: "0.6px",

    zIndex: 2,
  }}
>
  Industry Insights on Robotic Virtual Simulation
</div>


              <img
                src={contactImg}
                alt="Robotic Virtual Simulation"
                style={{
                  width: "100%",
                  height: "560px",
                  objectFit: "cover",
                  borderRadius: "5px",
                }}
              />
            </div>
          </div>

          {/* RIGHT FORM */}
          <div className="col-md-6">
            <form
      onSubmit={handleSubmit}
      style={{
        maxWidth: "600px",
        margin: "0 auto",
        backgroundColor: "#eef6fc",
        padding: "30px",
        borderRadius: "6px",
      }}
    >
      <input
        id="name"
        placeholder="Name"
        required
        value={formData.name}
        onChange={handleChange}
        style={inputStyle}
      />

      <input
        id="email"
        type="email"
        placeholder="Email"
        required
        value={formData.email}
        onChange={handleChange}
        style={inputStyle}
      />

      <input
        id="phone"
        placeholder="Phone"
        required
        value={formData.phone}
        onChange={handleChange}
        style={inputStyle}
      />

      <input
        id="dob"
        type="date"
        required
        value={formData.dob}
        onChange={handleChange}
        style={inputStyle}
      />

      <select
        id="gender"
        required
        value={formData.gender}
        onChange={handleChange}
        style={inputStyle}
      >
        <option value="">Select Gender</option>
        <option value="MALE">Male</option>
        <option value="FEMALE">Female</option>
        <option value="OTHER">Other</option>
      </select>

      <input
        type="file"
        accept=".pdf,.doc,.docx"
        onChange={handleResumeUpload}
        style={inputStyle}
      />

      <textarea
        id="message"
        rows="4"
        placeholder="Enter your message"
        required
        value={formData.message}
        onChange={handleChange}
        style={inputStyle}
      />

      <button
        type="submit"
        disabled={loading}
        style={{
          width: "100%",
          padding: "12px",
          background: "#0047ff",
          color: "#fff",
          border: "none",
          borderRadius: "25px",
          fontSize: "16px",
          fontWeight: "bold",
          cursor: "pointer",
        }}
      >
        {loading ? "Submitting..." : "SEND ENQUIRY"}
      </button>
    </form>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactForm;



